<template>
  <header
    class="fixed top-0 w-full bg-primary font-atlas-grotesk-regular z-40 left-0"
    :class="mobile ? 'border-black border-b' : ''"
  >
    <div class="mx-auto px-4 max-w-6xl">
      <div :class="!mobile ? 'border-black border-b' : ''">
        <component :is="menuComponent" :header="header" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  components: {
    Menu: () => import("@/components/header/Menu.vue"),
    MobileMenu: () => import("@/components/header/MobileMenu.vue"),
  },
  data() {
    return {
      header: null,
    };
  },
  created() {
    this.$api
      .get("/menu")
      .then((response) => {
        this.header = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    menuComponent() {
      return this.mobile ? "MobileMenu" : "Menu";
    },
  },
};
</script>